export enum DashboardBoxLayout {
  Normal = 1,
  Tile = 2,
  None = 3
}
